<script>
export default {
  props: {
    news: {
      type: Object,
    },
  },
};
</script>

<template>
  <div>
    <router-link :to="{name: 'OrganizationView', params: {id: news.textParams[0]}}"
    >{{news.textParams[1]}}</router-link>
    {{$t('news.template.org.updateAvatar.p1')}}
  </div>
</template>
